// ============================================================================
// TOPOLOGICAL SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'topological-sort',
  name: 'Topological Sort',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'A linear ordering of vertices in a directed acyclic graph (DAG) such that for every directed edge from vertex u to vertex v, u comes before v in the ordering. Used for task scheduling, dependency resolution, and course planning.'
};
